import script from "./Paginate.vue?vue&type=script&setup=true&lang=js"
export * from "./Paginate.vue?vue&type=script&setup=true&lang=js"

import "./Paginate.vue?vue&type=style&index=0&id=b96ae460&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/wp-content/themes/stewartrealtor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b96ae460"]])

export default __exports__